<app-pageheader Title="Threshold Sets">
  <add-button AddRoute="/parking/parking/thresholdsets/new/edit"></add-button>
</app-pageheader>

<app-datalistview [Columns]="Columns" [ShowMap]="false" ApiUrl="infrastructure/thresholdsets/searches"
  [AllowEdit]="true" EditUrl="/parking/parking/thresholdsets/:id/edit">
  <app-filter-set>
    <div app-search-filter></div>
    <div app-search-button></div>
  </app-filter-set>
</app-datalistview>